"use client"

import { cn } from "@/lib/utils"
import { X } from "lucide-react"
import * as React from "react"
import { Drawer as DrawerPrimitive } from "vaul"

const Drawer = ({
  shouldScaleBackground = true,
  direction = "right",
  ...props
}) => (
  <DrawerPrimitive.Root
    shouldScaleBackground={shouldScaleBackground}
    direction={direction}
    {...props}
  />
)

Drawer.displayName = "Drawer"

const DrawerTrigger = DrawerPrimitive.Trigger

const DrawerPortal = DrawerPrimitive.Portal

const DrawerClose = DrawerPrimitive.Close

const DrawerOverlay = React.forwardRef(({ className, ...props }, ref) => (
  <DrawerPrimitive.Overlay
    ref={ref}
    className={cn("fixed inset-0 z-50 bg-[rgba(0,0,0,0.5)]", className)}
    {...props}
  />
))

DrawerOverlay.displayName = DrawerPrimitive.Overlay.displayName

const DrawerContent = React.forwardRef(
  (
    {
      className,
      children,
      onClose,
      overlayClassName,
      showDragger = false,
      showCloseButton = true,
      closeButtonClassName,
      ...props
    },
    ref
  ) => (
    <DrawerPortal>
      <DrawerOverlay className={overlayClassName} />

      <DrawerPrimitive.Content
        ref={ref}
        className={cn(
          "fixed inset-x-0 bottom-0 z-50  flex h-screen flex-col bg-white px-3 pt-[30px]",

          className
        )}
        aria-describedby={undefined}
        {...props}
      >
        {showCloseButton && (
          <DrawerPrimitive.Close
            className={cn(
              "ring-offset-background focus_ring-ring data-[state=open]_text-muted-foreground absolute right-4 top-4 z-50 rounded-sm opacity-70 transition-opacity hover_opacity-100 focus_outline-none focus_ring-2 focus_ring-offset-2 disabled_pointer-events-none data-[state=open]_bg-accent",
              closeButtonClassName
            )}
            onClick={onClose}
          >
            <X className="h-6 w-6" />
            <span className="sr-only">Close</span>
          </DrawerPrimitive.Close>
        )}
        {showDragger && (
          <div className="bg-muted mx-auto mt-4 h-2 w-[100px] rounded-full" />
        )}
        {children}
      </DrawerPrimitive.Content>
    </DrawerPortal>
  )
)

DrawerContent.displayName = "DrawerContent"

const DrawerHeader = ({ className, ...props }) => (
  <div
    className={cn("grid gap-1.5 p-4 text-center sm_text-left", className)}
    {...props}
  />
)

DrawerHeader.displayName = "DrawerHeader"

const DrawerFooter = ({ className, ...props }) => (
  <div
    className={cn("mt-auto flex flex-col gap-2 p-4", className)}
    {...props}
  />
)

DrawerFooter.displayName = "DrawerFooter"

const DrawerTitle = React.forwardRef(({ className, ...props }, ref) => (
  <DrawerPrimitive.Title
    ref={ref}
    className={cn(
      "text-lg font-semibold leading-none tracking-tight",
      className
    )}
    {...props}
  />
))

DrawerTitle.displayName = DrawerPrimitive.Title.displayName

const DrawerDescription = React.forwardRef(({ className, ...props }, ref) => (
  <DrawerPrimitive.Description
    ref={ref}
    className={cn("text-muted-foreground text-sm", className)}
    {...props}
  />
))

DrawerDescription.displayName = DrawerPrimitive.Description.displayName

export {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerTitle,
  DrawerTrigger,
}
